import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { ISubcategoryContext, SubcategoryContext } from '../../../../../subcategoryState/subcategoryContext';
import style from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<ISubcategoryContext>(SubcategoryContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortBySubcategoryLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortBySubcategoryA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('SubcategoriesA-Z')}
						checked={sortBy === 'SubcategoriesA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortBySubcategoryZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('SubcategoriesZ-A')}
						checked={sortBy === 'SubcategoriesZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};
